import React from "react"

import UserIcon from "../../../../../../gd-components/icons/user/user"
import FieldViewForUser_ControlViewEmpty from "./value-empty"
import {FieldViewProps} from "../../../../../render/view"

type Props = {
    option      : Option

    disabled?   : boolean

    onReset     : callback
} & FieldViewProps

// const debug = "FieldViewForUser_ControlViewNotEmpty"
const debug = false

export default function FieldViewForUser_ControlViewNotEmpty(props: Props) {

    const [showResetButton, setShowResetButton] = React.useState(false);

    const height = _.get(props.params, 'height', 28)

    const classes = Classes("ui5-control-button not-empty selected", 's-{0}'.f(height), props.className, {
        "disabled"                          : props.disabled
    })

    if(props.option.value === gd.session.me.id){
        return <FieldViewForUser_ControlViewEmpty className = {props.className}
                                                  field     = {props.field}
                                                  model     = {props.model}
                                                  disabled  = {props.disabled}
                                                  children  = {props.children}
                                                  onClick   = {props.onClick}/>
    }

    const onMouseEnter = ()=>{
        setShowResetButton(true)
    }

    const onMouseLeave = ()=>{
        setShowResetButton(false)
    }

    const onClick = ()=>{
        props.onClick?.(props.option.value)
    }

    const onReset = (e: React.SyntheticEvent)=>{
        e.stopPropagation()
        props.onReset()
    }

    const iconSize = _.get(props.params, 'iconSize', 22).toString()

    debug && console.log(debug, 'render', props.option.value, iconSize)

    return (
        <>
            <div className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

                <UserIcon className="m-r-8" userId={props.option.value} size={iconSize}/>

                <div className="ui5-txt-not-important-small lh-13em">{props.option.label}</div>

                <div className="flex-row-right-center">

                    {!props.disabled && showResetButton &&
                        <div className="ui5-ico-delete s16 red m-l-5" onClick={onReset}/>
                    }

                    {!showResetButton && <div className="btn-arrow flex-row-center-center w-16 m-l-5"/>}

                </div>
            </div>

            {props.children}
        </>
    )
}
